// Block doctors js

$(function () {
  $('.jsBlockDoctorsCarousel').owlCarousel({
    loop: true,
    nav: false,
    items: 1,
    smartSpeed: 500,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true
  });
})
